import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";

function ContactForm() {
  const form = useRef(null);
  const [sending, setSending] = useState(false);

  const sendEmail = async (e) => {
    e.preventDefault();
    setSending(true);

    try {
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

      if (!serviceId || !templateId || !publicKey) {
        throw new Error("EmailJS environment variables non configurate.");
      }

      const result = await emailjs.sendForm(serviceId, templateId, form.current, publicKey);
      console.log("EmailJS result:", result);

      alert("✅ Messaggio inviato con successo! Ti risponderemo il prima possibile.");
      form.current.reset();

    } catch (err) {
      console.error("Errore invio email:", err);
      alert("❌ Si è verificato un errore durante l’invio. Riprova più tardi o contattaci via telefono.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contact-form">
      <p className="mb-4" style={{ fontSize: "1.1rem" }}>
        Compila il form qui sotto e lasciaci un messaggio: saremo lieti di rispondere alle tue esigenze
        e di fornirti soluzioni su misura per te.
      </p>

      <form ref={form} onSubmit={sendEmail}>
        <div className="w3-section">
          <label className="fw-bold">Nome</label>
          <input
            className="w3-input w3-border"
            type="text"
            name="from_name"
            required
            placeholder="Il tuo nome"
          />
        </div>

        <div className="w3-section">
          <label className="fw-bold">Email</label>
          <input
            className="w3-input w3-border"
            type="email"
            name="from_email"
            required
            placeholder="nome@email.com"
          />
        </div>

        <div className="w3-section">
          <label className="fw-bold">Messaggio</label>
          <textarea
            className="w3-input w3-border"
            name="message"
            rows="5"
            required
            placeholder="Scrivi qui il tuo messaggio..."
          />
        </div>

        <button
          type="submit"
          className="w3-block w3-padding-large btn btn-warning w3-margin-bottom"
          style={{ fontWeight: "bold", borderRadius: "8px" }}
          disabled={sending}
        >
          {sending ? "Invio in corso…" : "Invia Email"}
        </button>
      </form>
    </div>
  );
}

export default ContactForm;
